import {makeObservable, observable} from "mobx";
import SaporeForm from "../../forms/SaporeForm";
import EmailField from "../../forms/fields/EmailField";
import PasswordField from "../../forms/fields/PasswordField";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../components/toast/ErrorToast";

export class LoginFeature {
    constructor(application, navigator) {
        this._application = application;
        this._form = this._createForm();

        makeObservable(this, {
            _form: observable,
        })
    }

    _createForm() {
        const fields = {
            "email": new EmailField(false),
            "password": new PasswordField(false)
        }
        return new SaporeForm(fields)
    }

    get form() {
        return this._form;
    }

    set form(value) {
        this._form = value;
    }

    emailField() {
        return this.form.getFieldByName("email")
    }

    passwordField() {
        return this.form.getFieldByName("password")
    }

    updateEmail(value) {
        this.emailField().updateValue(value)
    }

    updatePassword(value) {
        this.passwordField().updateValue(value)
    }

    async login(onLoginSuccessCallback) {
        const email = this.emailField().value;
        const password = this.passwordField().value;
        const apiClient = this._application.apiClient();
        const response = await apiClient.signInOnAuthenticationMethod(email, password)
        if (response.hasErrors()) {
            return errorToast("No se pudo iniciar sesión")
        }
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                const loginCompleted = await this._application.session().successfulLoginOf(email)
                if (!loginCompleted) {
                    return errorToast("No se pudo iniciar sesión")
                }
                onLoginSuccessCallback()
            },
            handlesError: (response) => {
                errorToast("No se pudo iniciar sesión")
            }
        });
        return apiClient.login(email, password, responseHandler)
    }
}